<style scoped>
    .demo-drawer-footer {
        width: 400px;
        position: fixed;
        bottom: 0;
        right: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }

    .tablelist {
        border: 1px solid #fff;
        border-collapse: collapse; /* 边框重叠 */
        width: 100%;
    }

    .tablelist td {
        border: 1px solid #fff;
        height: 47px;
        line-height: 47px;
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
        background: #f2f2f2;
        user-select: none;
    }

    .tablelist td:active, .tablelist td:focus {
        background: #fff;
    }

    .colorPannel {
        height: 30px;
        width: 30px;
        border-radius: 50%;
        display: inline-block;
        margin-left: 20px;
    }
</style>
<template>
    <div>
        <div v-if="page>1">
            <img style="width: 25px;height: 30px;padding-bottom: 10px" src="@/assets/img//last.png">
        </div>
        <div v-if="areaList.length>0" class="tf-table">
            <div v-for="(item,index) in areaList" :key="index">
                <li tapmode="active-style" style="height: 40px" @click="selectArea(item)">
                    <span style="color: black;font-size: 15px" >{{item.areaName}}</span>
                </li>
            </div>


        </div>

        <div  class="demo-drawer-footer">
            <Button style="margin-right: 8px" @click="onCancel">取消</Button>
        </div>
    </div>
</template>

<script>
    import xl from '@/assets/img/lx/xl.png';

    export default {
        props: ['sbinfo'],

        data() {
            return {
                xl: xl,

                src: '',

                fllist: [],

                //定时
                csTime: 0,
                runTime: 0,// 连续运行时间
                //设备开关
                issbSwitch: false,

                // 设备详情
                con: '',
                path: '',
                areaList: [],
                dataList: [],
                page: 0,
                statu: 0,
                filePath: '未选择歌曲',
                volume: 20,
                length: 100,
                time_pos: 0,
                progress: 0,
                chaPopShow: false,
                chaText: '定阻定压',
                chaList: ['定阻', '定压', '定阻定压'],
                cha: 2,
            };
        },
        computed: {},
        watch: {},
        created(){
            this.listArea();
        },
        methods: {
            listArea(){
                var that = this;
                that.$func.ajax('listArea', {
                    token: that.$func.getToken(),
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        if (r.type.length > 0) {
                            that.areaList = r.type;
                        }

                    }
                })
            },
            selectArea(area){
                console.log("asdasdasdasdsad")
                this.$store.commit('setAreaId',area);
                this.$emit('dapingRefresh',area);
            },
            onRepeatConfirm(val){
                var that = this;
                console.log(val);
                that.chaText = val.value;
                that.chaList.map(function (item, index) {
                    if (item == val.value) {
                        that.cha = index;
                    }
                })
                console.log(that.cha);
            },
            onCancel(){
                this.src = "";
                this.$emit('close');
            },
            /**
             * 时间秒数格式化
             * @param s 时间戳（单位：秒）
             * @returns {*} 格式化后的时分秒
             */
        },
        mounted()
        {

        },
    };
</script>